<template>
  <div class="wc-layout wc-layout--mobile-default">
    <WCMobileHeaderV2 class="mobile-header" />
    <div class="wc-mobile-header-padding">
      <WCWebAds v-if="hasWebAds" :webAds="webAds" :key="this.webAdKey" />
      <!-- Based on employee status classes are added dynamically -->
      <div class="container-fluid" :class="layoutBodyClass">
        <WCAlertRoot />
        <router-view />
      </div>
    </div>
    <WCEmployeeAssociationBanner v-if="isEmployee && isCustomer" />
    <WCBottomNavigation v-if="showBottomNavigation" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import WCAlertRoot from '@/modules/alerts/components/WCAlertRoot/WCAlertRoot.vue';
import WCBottomNavigation from '@/components/WCBottomNavigation/WCBottomNavigation.vue';
import WCMobileHeaderV2 from '@/components/WCMobileHeaderV2/WCMobileHeaderV2.vue';
import EmployeeMixin from '@/modules/employee/mixins/EmployeeMixin';
import WCWebAds from '@/components/WCWebAds/WCWebAds.vue';
import WCEmployeeAssociationBanner from '@/modules/employee/components/WCEmployeeAssociationBanner/WCEmployeeAssociationBanner.vue';
import IneligibleCartCheckMixin from '@/mixins/IneligibleCartCheckMixin';
import MobileHeaderHeightMixin from '@/mixins/MobileHeaderHeightMixin';

export default {
  name: 'MobileDefault',
  components: {
    WCMobileHeaderV2,
    WCWebAds,
    WCAlertRoot,
    WCBottomNavigation,
    WCEmployeeAssociationBanner,
  },
  mixins: [EmployeeMixin, IneligibleCartCheckMixin, MobileHeaderHeightMixin],
  computed: {
    ...mapGetters({
      isCustomerModeScan: 'user/isCustomerModeScan',
      cartOrderType: 'cart/getCartOrderType',
      webAds: 'browse/getWebAds',
    }),
    layoutBodyClass() {
      return [
        this.bodyClass,
        { 'wc-layout__body--no-padding': this.$route.meta.mobileNoBodyPadding },
      ];
    },
    isShortHeader() {
      return !this.isMultiStore && !this.$configuration.orderTypesEnabled;
    },
    /**
     * Property to check if multistore
     */
    isMultiStore() {
      return this.$configuration.multistore;
    },
    /**
     * Construct classname for layout body
     */
    bodyClass() {
      if (
        (!this.isEmployee || (this.isEmployee && this.isCustomer)) &&
        ((!this.isMultiStore &&
          this.$configuration.orderTypesEnabled &&
          !this.isCustomerModeScan) ||
          (this.isMultiStore && !this.isCustomerModeScan))
      ) {
        return this.hasWebAds ? 'wc-layout__body__web-ads' : 'wc-layout__body';
      }
      if (this.isCustomerModeScan || this.isShortHeader) {
        return 'default-page__body-scan-mode';
      }
      return 'wc-employee-layout__body';
    },
    showBottomNavigation() {
      return (
        !this.$route.meta.hideBottomNav &&
        (!this.isEmployee || (this.isEmployee && this.isCustomer))
      );
    },
    hasWebAds() {
      return this.webAds && this.webAds.length;
    },
    webAdKey() {
      return JSON.stringify(this.webAds); // Needed to force WebAds to reload if new images are required.
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-layout--mobile-default {
  .wc-layout__body {
    padding-top: 0.6rem;
    // The fixed nav's true footprint on notched devices is its own height plus the bottom
    // safe-area inset (see WCBottomNavigation.vue's `bottom: env(safe-area-inset-bottom)`),
    // so this padding must include that inset too or trailing content/buttons get cut off.
    padding-bottom: calc(#{$mobile-body-padding-bottom} + env(safe-area-inset-bottom, 0px));
  }
  .wc-layout__body__web-ads {
    padding-top: 0.6rem;
    padding-bottom: calc(#{$mobile-body-padding-bottom} + env(safe-area-inset-bottom, 0px));
  }
  .wc-layout__body--no-padding {
    padding: 0;
  }
  .wc-mobile-header-padding {
    padding-top: var(--mobile-header-height);
  }
  .wc-employee-layout__body {
    padding-top: $mobile-header-padding-top - 2rem;
    padding-bottom: calc(#{$mobile-body-padding-bottom} + env(safe-area-inset-bottom, 0px));
  }
  .default-page__body-scan-mode {
    padding-top: 0.6rem;
    padding-bottom: calc(
      #{$mobile-body-padding-bottom - 1.5rem} + env(safe-area-inset-bottom, 0px)
    );
  }
}
</style>
